import connect from 'components/Shared/connect';
import { isLayout, isMobile, isTablet } from 'components/Shared/responsive';
import DesktopMenu from './desktop';
import MobileMenu from './mobile';
import styles from './styles.scss';
import cn from 'classnames';

interface OwnProps {
  className?: string;
}
interface MergedProps extends OwnProps {
  isDrawer: boolean;
}

export default connect<MergedProps, OwnProps>(state => ({
  isDrawer: isLayout(isMobile, isTablet)(state)
}))(({ isDrawer, className }: MergedProps) => {
  return (
    <div className={cn(className, styles.base)}>
      {!isDrawer && <DesktopMenu />}
      {isDrawer && <MobileMenu />}
    </div>
  );
});
